// @flow
import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import downloadManager from './downloadManager'
import download from '../Download/Reducer/Download';
import playlist from './playlist'
import resource from './resource'
import session from './session'
import documentViewer from './documentViewer'
import settings from './settings'
import search from './search'
import ui from './ui'
import filters from './filters'
import nid from './nid'
import sensors from './sensors'
import tickets from './tickets'

const appReducer = combineReducers( {
    settings,
    playlist,
    resource,
    session,
    documentViewer,
    downloadManager,
    download,
    search,
    ui,
    filters,
    nid,
    sensors,
    tickets,
    router
} );

const rootReducer = (state, action) => {
    if (action.type === 'Session/LOG_OUT'){
        return appReducer(undefined, action)
    }

    return appReducer(state, action)
}

export default rootReducer;
